module.exports = __webpack_public_path__ + "static/media/j_of_diamonds2.0efe5110.png";